import { Info } from 'lucide-react'
import PropTypes from 'prop-types'
import React from 'react'

import { AdasButton, AdasPopover, AdasTypography } from '@components/wrapper-components'

export function InfoPopover({ text, ariaLabel, popoverWidth, popoverHeight, iconColor, enableClick = true, className = '', variant }) {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = (event) => {
    if (enableClick) {
      setAnchorEl(event.currentTarget)
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <>
      <AdasButton
        buttonType='iconButton'
        aria-label={ariaLabel}
        style={{ color: iconColor || '#1F6FEB' }}
        className={className}
        onClick={handleClick}
        size='small'
      >
        <Info className='w-4 h-4' />
      </AdasButton>
      <AdasPopover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: variant === 'top-right' ? 'right' : 'center'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: variant === 'top-right' ? 'left' : 'center'
        }}
      >
        <AdasTypography className='py-[2%] px-[5%]' style={{ maxWidth: popoverWidth || 600, height: popoverHeight || 'auto' }}>
          {text}
        </AdasTypography>
      </AdasPopover>
    </>
  )
}

InfoPopover.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  text: PropTypes.node,
  popoverWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  popoverHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string,
  enableClick: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.string
}
